<div class="activation">
  <form class="container" (ngSubmit)="verifyActivationCode()">
    <img alt="CapriXpress Logo" class="logo" height="512" ngSrc="../../assets/img/logo.svg" width="512" priority/>
    <p class="title">Welkom bij CapriXpress! <br/> Vul om te starten je activatie code in.</p>

    <input
      (ngModelChange)="errorMessage = ''"
      [(ngModel)]="activationCode"
      class="input"
      placeholder="Je activatie code"
      type="text"
      name="activationCode"
    />

    <button [disabled]="activationCode.length <= 0" class="button" type="submit">
      Activeer
    </button>

    <p *ngIf="errorMessage" class="error" style="padding-top: 0.5rem">{{ errorMessage }}</p>
  </form>
</div>

<img [src]="'../../../../assets/backgrounds/' + gameService.backgroundUrl" alt="summer background" class="blurred-img"/>
